import { Center } from '@/components/ui/center'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { Stack, useRouter } from 'expo-router'
import { FileQuestionIcon } from 'lucide-react-native'
import { View } from 'react-native'

import { Button, ButtonText } from '@/components/ui/button'

export default function NotFoundScreen() {
  const router = useRouter()
  const [secondaryLabel, systemOrange] = usePlatformColor('secondaryLabel', 'systemOrange')

  return (
    <>
      <Stack.Screen options={{ title: '页面不存在', headerLargeTitle: false }} />
      <Center className="flex-1 px-10">
        <VStack space="md" className="items-center">
          <View className="w-20 h-20 rounded-full bg-orange-100 dark:bg-orange-900/30 items-center justify-center mb-2">
            <FileQuestionIcon size={40} color={systemOrange as string} />
          </View>
          <Text size="xl" className="font-semibold">
            页面不存在
          </Text>
          <Text size="md" style={{ color: secondaryLabel }} className="text-center">
            你访问的页面不存在或已被移除
          </Text>
        </VStack>
        <Button
          size="lg"
          className="w-full max-w-sm mt-10"
          onPress={() => (router.canDismiss() ? router.dismissAll() : router.replace('/'))}
        >
          <ButtonText>返回首页</ButtonText>
        </Button>
      </Center>
    </>
  )
}
